import { render, staticRenderFns } from "./CodeWxLogin.vue?vue&type=template&id=304f529c&scoped=true"
import script from "./CodeWxLogin.vue?vue&type=script&lang=js"
export * from "./CodeWxLogin.vue?vue&type=script&lang=js"
import style0 from "./CodeWxLogin.vue?vue&type=style&index=0&id=304f529c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f529c",
  null
  
)

export default component.exports